import React from 'react';
import isUndefined from 'lodash/isUndefined';

import Form from './components/Form';
import ErrorMessage from './components/ErrorMessage';
import WarningMessage from './components/WarningMessage';
import SuccessMessage from './components/SuccessMessage';
import ProcessingMessage from './components/ProcessingMessage';

import useTemplateState from './hooks/useTemplateState';

const Template: React.FC = () => {
    const {isError, isSuccess, connectionValid, templateData, isLoadingConnect, isLoadingSign} = useTemplateState();

    const noConnect = !isUndefined(connectionValid) && !connectionValid;
    const isErrorAfterConnect = (isError || !templateData) && !isLoadingConnect;

    if (isLoadingSign) {
        return <ProcessingMessage />;
    }

    if (noConnect) {
        return <WarningMessage />;
    }

    if (isSuccess) {
        return <SuccessMessage />;
    }

    if (isErrorAfterConnect) {
        return <ErrorMessage />;
    }

    return <Form />;
};

export default Template;
